import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WebServiceEndpoints } from '@common/web-service-endpoints';

export interface IGetCallBySessionRedirectUrlResponse {
  Deeplink: string;
}

@Injectable()
export class RedirectService {
  constructor(private readonly http: HttpClient) {}

  async fetchCallBySessionDeeplink(sessionId: string): Promise<IGetCallBySessionRedirectUrlResponse> {
    const request = {
      SessionId: sessionId,
    };

    return this.http
      .post<IGetCallBySessionRedirectUrlResponse>(WebServiceEndpoints.Deeplink.callBySession, request)
      .toPromise();
  }
}
